const LIST_SEGMENT = '/list'
const DETAIL_SEGMENT = '/detail'

const normalizeRoutePath = (value = '') => String(value).replace(/^\/+|\/+$/g, '')

export const getDynamicDetailPath = (route) => {
  if (!route?.dynamic) return undefined

  const routePath = normalizeRoutePath(route.path || route.key)
  if (!routePath) return undefined

  if (routePath.endsWith(LIST_SEGMENT)) {
    return routePath.slice(0, -LIST_SEGMENT.length) + DETAIL_SEGMENT
  }
  if (routePath.endsWith(DETAIL_SEGMENT)) {
    return routePath
  }

  return routePath + DETAIL_SEGMENT
}

export const applyDynamicDetailRouteConfig = (route) => {
  const detailPath = getDynamicDetailPath(route)
  if (!detailPath) return route

  return {
    ...route,
    detailPath: route.detailPath || detailPath,
    detailFormRoute: route.detailFormRoute || detailPath,
  }
}
